export const AccessUsers = [
  "6005300234",
  "9999666213",
  "6239048865",
  "9888798123",
  "9527808994",
  "8559829702",
];

export const canView = (mobile) =>
  AccessUsers.includes(mobile);
